module.exports = __webpack_public_path__ + "img/birthEngraving@2x.6c5ddc5.webp";